<template>
  <div id="box">
    <!-- 顶部起始位置 -->
    <historyTag :historyArr="historyArr"></historyTag>
    <!-- 顶部结束位置 -->

    <div id="mainBox">
      <div v-if="isPage == 'index'" class="body">
        <div class="flex">
          <ul class="topBox">
            <li class="flex">
              <div style="width: 240px">
                <el-input v-model="searchVle" placeholder="请输入品牌名称"></el-input>
              </div>
            </li>

            <li class="flex" style="padding-top: 5px">
              <el-button type="success" size="small" @click="searchFn">搜索</el-button>
            </li>
          </ul>

          <div class="top_right">
            <el-button type="success" size="small" @click="addFn">新增</el-button>
            <el-button type="primary" size="small" @click="openImportDialog">导入品牌型号</el-button>
            <el-button type="warning" size="small" @click="openSpectrumUploadDialog">批量上传图谱</el-button>
            <el-button type="warning" size="small" @click="openTypeImageUploadDialog">批量上传型号图片</el-button>
          </div>
        </div>

        <!-- 主体内容 -->
        <div>
          <el-table :data="tableData" border style="width: 100%; margin-top: 10px">
            <el-table-column prop="name" align="center" label="品牌名称">
            </el-table-column>

            <el-table-column prop="englishName" align="center" label="英文名称">
            </el-table-column>

            <el-table-column prop="batchExample" align="center" label="批号实例" width="100">
            </el-table-column>

            <el-table-column align="center" label="品牌案例图" width="110">
              <template slot-scope="scope">
                <div class="goodsImg" v-if="scope.row.brandExampleImage">
                  <img style="width: 50px; height: 50px; object-fit: contain" :src="scope.row.brandExampleImage" alt="" @click="previewFn(scope.row.brandExampleImage)" />
                </div>
                <span v-else style="color: #999;">暂无</span>
              </template>
            </el-table-column>

            <el-table-column align="center" label="型号">
              <template slot-scope="scope">
                <el-button type="success" size="small" @click="goTypeFn(scope.row)"
                  >管理</el-button
                >
              </template>
            </el-table-column>

            <el-table-column width="380" align="center" label="操作">
              <template slot-scope="scope">
                <el-button type="primary" size="small" @click="linkLogicFn(scope.row)">关联逻辑</el-button>
                <el-button type="info" size="small" @click="viewLogicsFn(scope.row)">查看关联逻辑</el-button>
                <el-button type="success" size="small" @click="editFn(scope.row)"
                  >编辑</el-button
                >
                <el-button type="danger" size="small" @click="delFn(scope.$index)"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>

          <div class="page_box">
            <el-pagination
              @current-change="changePage"
              :current-page.sync="currentPage"
              :page-size="pageSize"
              layout="total, prev, pager, next,jumper"
              :total="tableTotal"
            >
            </el-pagination>
          </div>
        </div>
        <!-- 主体内容 -->
      </div>

      <!-- 发货 -->
      <div class="excellent_box" v-if="excellenShow == 1">
        <div class="excellent_main brand-dialog-main">
          <div class="excellent_top">
            新增品牌
            <i class="el-icon-close" @click.stop="closeFn"></i>
          </div>

          <div class="excellent_content brand-dialog-content">
            <div class="excellent_li flex">
              <span>品牌名称：</span>
              <div style="width: 290px">
                <el-input
                  size="medium"
                  v-model="addList.name"
                  placeholder="请填写品牌名称"
                ></el-input>
              </div>
            </div>

            <div class="excellent_li flex">
              <span>英文名称：</span>
              <div style="width: 290px">
                <el-input
                  size="medium"
                  v-model="addList.englishName"
                  placeholder="请填写英文名称"
                ></el-input>
              </div>
            </div>

            <div class="excellent_li flex">
              <span>批号实例：</span>
              <div style="width: 290px">
                <el-input
                  size="medium"
                  v-model="addList.batchExample"
                  placeholder="请输入批号示例，如 20240319-A001"
                ></el-input>
              </div>
            </div>

            <div class="excellent_li flex">
              <span>批号说明图：</span>
              <div style="width: 290px; display: flex; align-items: center;">
                <div style="width: 100px; height: 100px">
                  <elUpload @getImg="getImgFn" :image="addList.brandExampleImage"></elUpload>
                </div>
                <el-button v-if="addList.brandExampleImage" type="danger" size="mini" @click="addList.brandExampleImage = ''" style="margin-left: 10px;">清空</el-button>
              </div>
            </div>
          </div>
          <div class="excellent_btn flex">
            <el-button type="success" size="small" @click.stop="excellentFn"
              >提交</el-button
            >
            <el-button type="info" size="small" @click.stop="closeFn">取消</el-button>
          </div>
        </div>
      </div>

      <modelBox
        v-if="isPage == 'modelBox'"
        :dataList="dataList"
        @return="returnFn"
      ></modelBox>
    </div>

    <!-- 新增数据弹框 -->
    <popupBox title="输入密码" v-if="isPopup">
      <div class="popupMain">
        <div class="addLi flex">
          <div class="addLi_title">密码:</div>

          <div class="addLi_content flex">
            <div style="width: 100%">
              <el-input v-model="passwordVle" placeholder="请输入"></el-input>
            </div>
          </div>
        </div>
      </div>

      <div class="popupBtn flex">
        <el-button type="success" size="small" @click="confirmPasswordFn">确认</el-button>
        <el-button type="info" size="small" @click="closePasswordFn">取消</el-button>
      </div>
    </popupBox>
    <!-- 新增数据弹框 -->

    <!-- 查看关联逻辑弹窗 -->
    <div class="excellent_box" v-if="viewLogicsShow">
      <div class="excellent_main" style="height: 400px; width: 600px;">
        <div class="excellent_top">
          关联逻辑列表
          <i class="el-icon-close" @click.stop="closeViewLogicsFn"></i>
        </div>

        <div class="excellent_content" style="max-height: 320px; overflow-y: auto;">
          <el-table border :data="linkedLogicsList" style="width: 100%" v-if="linkedLogicsList.length > 0">
            <el-table-column prop="code" align="center" label="规则编码">
            </el-table-column>
            <el-table-column prop="name" align="center" label="规则名称">
            </el-table-column>
            <el-table-column prop="description" align="center" label="规则描述" min-width="200">
            </el-table-column>
            <el-table-column align="center" label="操作" width="100">
              <template slot-scope="scope">
                <el-button type="danger" size="small" @click="delLinkedLogicFn(scope.$index)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <div v-else style="text-align: center; padding: 20px; color: #999;">
            暂无关联逻辑
          </div>
        </div>
      </div>
    </div>

    <!-- 关联逻辑弹窗 -->
    <div class="excellent_box" v-if="linkLogicShow">
      <div class="excellent_main">
        <div class="excellent_top">
          关联逻辑
          <i class="el-icon-close" @click.stop="closeLinkLogicFn"></i>
        </div>

        <div class="excellent_content">
          <div class="excellent_li flex">
            <span>选择逻辑规则：</span>
            <div style="width: 290px">
              <el-select
                v-model="selectedLogicCode"
                filterable
                placeholder="请选择逻辑规则"
                style="width: 100%"
              >
                <el-option
                  v-for="(item, index) in logicData"
                  :value="item.code"
                  :key="index"
                  :label="item.name + ' (' + item.code + ')'"
                >
                </el-option>
              </el-select>
            </div>
          </div>

          <div class="excellent_btn flex">
            <el-button type="success" size="small" @click.stop="confirmLinkLogicFn">提交</el-button>
            <el-button type="info" size="small" @click.stop="closeLinkLogicFn">取消</el-button>
          </div>
        </div>
      </div>
    </div>

    <!-- 导入品牌型号弹框 -->
    <uploadModal
      :visible="importDialogVisible"
      @close="closeImportDialog"
      @success="onImportSuccess"
    ></uploadModal>

    <!-- 批量上传图谱弹框 -->
    <uploadSpectrumModal
      :visible="spectrumUploadVisible"
      @close="closeSpectrumUploadDialog"
      @success="onSpectrumUploadSuccess"
    ></uploadSpectrumModal>

    <!-- 批量上传型号图片弹框 -->
    <uploadTypeImageModal
      :visible="typeImageUploadVisible"
      @close="closeTypeImageUploadDialog"
      @success="onTypeImageUploadSuccess"
    ></uploadTypeImageModal>
  </div>
</template>

<script>
import { delTips, returnTime, throttle } from "@/util/utils";
import modelBox from "./model.vue";
import elUpload from "@/components/elUpload";
import popupBox from "@/components/popupBox";
import uploadModal from "./uploadModal.vue";
import uploadSpectrumModal from "./uploadSpectrumModal.vue";
import uploadTypeImageModal from "./uploadTypeImageModal.vue";

export default {
  components: {
    modelBox,
    elUpload,
    popupBox,
    uploadModal,
    uploadSpectrumModal,
    uploadTypeImageModal,
  },
  data() {
    return {
      isPage: "index",

      dataList: {},

      surplusShow: 0,
      userList: "",

      // 输入密码
      isPopup: true,
      passwordVle: "",
      tempPassword: "Csj12321",

      // 历史记录
      historyArr: ["品牌管理"],

      //  搜索
      searchVle: "",

      // 查看关联逻辑相关
      viewLogicsShow: false,
      linkedLogicsList: [],
      currentBrandId: null, // 当前查看的品牌ID

      // 关联逻辑相关
      linkLogicShow: false,
      selectedLogicCode: "",
      logicData: [],
      currentLinkBrandId: null, // 当前关联的品牌ID

      // 导入品牌型号
      importDialogVisible: false,

      // 批量上传图谱
      spectrumUploadVisible: false,

      // 批量上传型号图片
      typeImageUploadVisible: false,

      // 品牌
      excellenShow: 0,

      // 添加数据
      addList: {
        name: "",
        englishName: "",
        batchExample: "",
        brandExampleImage: "",
      },

      // 数据信息
      tableData: [],
      pageSize: 10,
      currentPage: 1,
      tableTotal: 0,
    };
  },
  mounted() {
    this.selListFn(1);
  },
  methods: {
    // 搜索
    searchFn: function (res) {
      this.selListFn(1);
      this.currentPage = 1;
    },

    // 确认
    confirmPasswordFn() {
      let vle = this.passwordVle;
      if (!vle) {
        this.$message.error("请输入密码");
        return;
      }
      if (this.tempPassword != vle) {
        this.$message.error("您输入的密码不正确，请认证核对");
        return;
      }

      this.isPopup = false;
    },

    // 取消
    closePasswordFn() {
      this.$router.push({ path: "/user" });
    },

    // 图片预览
    previewFn(path) {
      window.open(path);
    },

    // 型号管理
    goTypeFn(list) {
      this.dataList = list;
      this.historyArr.push(list.name);
      this.isPage = "modelBox";
    },

    // 新增
    addFn() {
      this.addList = {
        name: "",
        englishName: "",
        batchExample: "",
        brandExampleImage: "",
      };
      this.excellenShow = 1;
    },

    // 品牌案例图上传回调
    getImgFn(path) {
      this.addList.brandExampleImage = path;
    },

    // 打开导入弹框
    openImportDialog() {
      this.importDialogVisible = true;
    },

    // 关闭导入弹框
    closeImportDialog() {
      this.importDialogVisible = false;
    },

    // 导入成功回调
    onImportSuccess() {
      this.closeImportDialog();
      this.selListFn(1); // 刷新列表
    },

    // 打开批量上传图谱弹框
    openSpectrumUploadDialog() {
      this.spectrumUploadVisible = true;
    },

    // 关闭批量上传图谱弹框
    closeSpectrumUploadDialog() {
      this.spectrumUploadVisible = false;
    },

    // 批量上传图谱成功回调
    onSpectrumUploadSuccess() {
      this.closeSpectrumUploadDialog();
      this.selListFn(1); // 刷新列表
    },

    // 打开批量上传型号图片弹框
    openTypeImageUploadDialog() {
      this.typeImageUploadVisible = true;
    },

    // 关闭批量上传型号图片弹框
    closeTypeImageUploadDialog() {
      this.typeImageUploadVisible = false;
    },

    // 批量上传型号图片成功回调
    onTypeImageUploadSuccess() {
      this.closeTypeImageUploadDialog();
      this.selListFn(1); // 刷新列表
    },

    // 查看关联逻辑
    viewLogicsFn: function (list) {
      this.currentBrandId = list.id;
      this.linkedLogicsList = [];
      this.viewLogicsShow = true;
      this.getLogicsByBrandId(list.id);
    },

    // 关闭查看关联逻辑弹窗
    closeViewLogicsFn: function () {
      this.viewLogicsShow = false;
      this.linkedLogicsList = [];
      this.currentBrandId = null;
    },

    // 根据品牌ID获取关联逻辑列表
    getLogicsByBrandId: function (brandId) {
      if (!brandId) {
        this.$message.error("品牌ID不能为空");
        return;
      }

      var url = this.$api.api.getLogicsByBrandId + brandId;
      this.$https(url, {}, "GET").then((res) => {
        if (res.data.code == 200) {
          this.linkedLogicsList = res.data.data || [];
        } else {
          this.linkedLogicsList = [];
          this.$message.error(res.data.msg || "查询失败");
        }
      });
    },

    // 删除关联逻辑
    delLinkedLogicFn: delTips(function (index) {
      var logic = this.linkedLogicsList[index];
      if (!logic) {
        this.$message.error("逻辑信息不完整");
        return;
      }

      // 使用关联关系的 id，如果返回的数据中有关联关系 id，使用关联关系 id
      // 否则可能需要使用其他字段，比如 relationId 或 id
      var relationId = logic.relationId || logic.id;

      if (!relationId) {
        this.$message.error("关联关系ID不能为空");
        return;
      }

      var url = this.$api.api.removeBrandBatchCalLogic + relationId;
      this.$https(url, {}, "POST").then((res) => {
        if (res.data.code == 200) {
          this.$message.success("删除成功");
          // 重新获取关联逻辑列表
          this.getLogicsByBrandId(this.currentBrandId);
        } else {
          this.$message.error(res.data.msg || "删除失败");
        }
      });
    }),

    // 关联逻辑
    linkLogicFn: function (list) {
      this.currentLinkBrandId = list.id;
      this.selectedLogicCode = "";
      this.linkLogicShow = true;
      // 如果逻辑列表为空，则获取逻辑列表
      if (this.logicData.length === 0) {
        this.selLogicListFn();
      }
    },

    // 关闭关联逻辑弹窗
    closeLinkLogicFn: function () {
      this.linkLogicShow = false;
      this.selectedLogicCode = "";
      this.currentLinkBrandId = null;
    },

    // 确认关联逻辑
    confirmLinkLogicFn: function () {
      if (!this.selectedLogicCode) {
        this.$message.error("请选择逻辑规则");
        return;
      }

      if (!this.currentLinkBrandId) {
        this.$message.error("品牌ID不能为空");
        return;
      }

      var obj = {
        brandId: this.currentLinkBrandId,
        batchCalLogicCode: this.selectedLogicCode
      };

      this.$https(this.$api.api.saveBrandBatchCalLogic, obj, "POST").then((res) => {
        if (res.data.code == 200) {
          this.$message.success("关联成功");
          this.closeLinkLogicFn();
          this.selListFn(this.currentPage);
        } else {
          this.$message.error(res.data.msg || "关联失败");
        }
      });
    },

    // 查询逻辑规则列表
    selLogicListFn: function () {
      var obj = {
        page: 1,
        size: 1000,
      };

      this.$https(this.$api.api.selBatchCalLogic, obj, "GET").then((res) => {
        if (res.data.code == 200) {
          this.logicData = res.data.data || [];
        } else {
          this.logicData = [];
          this.$message.error(res.data.msg || "获取逻辑列表失败");
        }
      });
    },

    // 编辑
    editFn: function (list) {
      this.addList = list;
      this.historyArr.push("编辑");
      this.excellenShow = 1;
    },

    closeFn: function () {
      this.excellenShow = 0;
      this.pageChangeShow = 1;
      this.selListFn(this.currentPage);
    },

    excellentFn: throttle(function () {
      var data = this.addList;
      if (!data.name) {
        this.$message.error("请输入品牌名称");
        return;
      } else if (!data.englishName) {
        this.$message.error("请输入英文名称");
        return;
      }
      var obj = {
        name: data.name,
        englishName: data.englishName,
        batchExample: data.batchExample || "",
        brandExampleImage: data.brandExampleImage || "",
      };

      let urls = this.$api.api.addBrand;
      if (data.id) {
        urls = this.$api.api.upBrand;
        obj.id = data.id;
      }

      // return
      this.$https(urls, obj, "POST").then((res) => {
        if (res.data.code == 200) {
          this.$message.success("操作成功");
          this.closeFn();
        } else {
          this.$message.error("操作失败");
        }
      });
    }),

    // 查询
    selListFn: function (page) {
      var obj = {
        page: page,
        size: this.pageSize,
      };

      if (this.searchVle) {
        obj.name = this.searchVle;
      }

      this.$https(this.$api.api.selBrand, obj, "POST").then((res) => {
        if (res.data.code == 200) {
          var data = res.data.data;
          data.forEach((v) => {
            v.eTime = v.expiretime ? returnTime(new Date(v.expiretime)) : "";
          });
          this.tableData = data;
          this.tableTotal = res.data.size;
        } else {
          this.tableData = [];
          this.tableTotal = 0;
        }
      });
    },

    // 返回
    returnFn(res) {
      this.selListFn(this.currentPage);
      this.isPage = "index";
      this.historyArr.pop();
    },

    // 分页
    changePage: function (res) {
      this.selListFn(res);
    },

    // 删除
    delFn: delTips(function (index) {
      var list = this.tableData[index];

      this.$https(
        this.$api.api.delBrand,
        {
          id: list.id,
        },
        "GET"
      ).then((res) => {
        if (res.data.code == 200) {
          this.selListFn(this.currentPage);
          this.$message.success("操作成功");
        } else {
          this.$message.error(res.data.msg);
        }
      });
    }),
  },
};
</script>

<style lang="less" scoped>
#box {
  width: 100%;

  .body {
    margin-top: 20px;
  }

  .top_right {
    display: flex;
  }

  .topBox {
    width: 100%;
    margin-top: 10px;
    overflow: hidden;
    font-size: 15px;

    li {
      float: left;
      margin-right: 20px;
      margin-bottom: 10px;

      .el-range-editor.el-input__inner {
        width: 290px;
      }
    }

    li:last-child {
      margin-right: 0px;
    }

    span {
      margin-right: 5px;
    }
  }
}

// 新增品牌
.excellent_box {
  width: 100%;
  height: 100vh;
  position: fixed;
  z-index: 1000;
  left: 0;
  top: 0;
  background: rgba(000, 000, 000, 0.5);

  .excellent_main {
    width: 450px;
    height: 250px;

    &.brand-dialog-main {
      height: 440px;
      display: flex;
      flex-direction: column;

      .excellent_top {
        flex-shrink: 0;
      }

      .brand-dialog-content {
        flex: 1;
        min-height: 0;
        overflow-y: auto;
      }

      .excellent_btn {
        flex-shrink: 0;
        margin-top: 15px;
        padding-bottom: 15px;
        justify-content: center;
      }
    }
    margin: auto;
    background: #fff;
    transform: translate(-50%, -50%);
    position: fixed;
    left: 50%;
    top: 50%;
    border-radius: 5px;
    overflow: hidden;

    .excellent_top {
      width: 96%;
      height: 40px;
      background: #eee;
      line-height: 40px;
      padding: 5px 2%;
      font-size: 15px;
      i {
        float: right;
        margin-top: 10px;
        font-size: 20px;
        cursor: pointer;
      }
    }

    .excellent_content {
      width: 100%;
      margin-top: 10px;

      .excellent_li {
        margin-top: 25px;

        .el-select {
          width: 100%;
        }

        span {
          width: 120px;
          display: inline-block;
          flex-shrink: 0;
          text-align: right;
        }
      }

      .excellent_btn {
        justify-content: flex-end;
        margin: 25px 15px 0px 0px;
      }
    }
  }
}
// 新增品牌

//弹框数据

.popupMain {
  width: 100%;
  padding: 5px 10px;
  box-sizing: border-box;

  .addLi {
    width: 100%;
    margin-top: 10px;

    .addLi_title {
      width: 80px;
      flex-shrink: 0;
    }

    .addLi_content {
      width: 100%;
    }
  }
}

.popupBtn {
  justify-content: flex-end;
  margin: 10px auto auto auto;

  .popupBtnLi {
    cursor: pointer;
    margin-right: 6px;
  }
}

// 弹框数据

// 标准图片
.coordinateImg {
  width: 100%;
  height: 80px;
}
// 标准图片
</style>



// WEBPACK FOOTER //
// src/pages/brand/index.vue